import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, Newspaper } from "@phosphor-icons/react";
import InteractionsPanel from "@/components/InteractionsPanel";
import Seo from "@/components/Seo";

export default function NewsDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/news/${id}`);
        setNews(data);
      } catch (e) {
        toast.error("Notícia não encontrada");
        navigate("/noticias");
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) return <div className="pt-32 text-center text-zinc-500 font-mono-accent text-xs">A CARREGAR...</div>;
  if (!news) return null;

  return (
    <div className="pt-20 max-w-3xl mx-auto px-5 lg:px-8 pb-24" data-testid="news-detail-page">
      <Seo title={news.title} description={news.summary} image={news.image_url} path={`/noticias/${id}`} type="article" />
      <Link to="/noticias" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-6">
        <ArrowLeft size={16} weight="bold" /> Voltar às notícias
      </Link>

      {news.image_url && (
        <div className="rounded-2xl overflow-hidden mb-8 border border-white/5 bg-[#0a0a0f]">
          <img src={news.image_url} alt={news.title} className="w-full h-auto object-contain max-h-[70vh] mx-auto block" />
        </div>
      )}

      <div className="font-mono-accent text-xs text-[#E63946] mb-2 flex items-center gap-2">
        <Newspaper size={14} weight="bold" /> {new Date(news.created_at).toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" })}
      </div>
      <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">{news.title}</h1>
      {news.summary && <p className="text-xl text-zinc-300 mt-6 leading-relaxed">{news.summary}</p>}
      {news.content && (
        <div
          className="news-content mt-8 text-zinc-300 leading-relaxed text-lg"
          data-testid="news-content"
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: news.content }}
        />
      )}
      <InteractionsPanel entityType="news" entityId={id} />
    </div>
  );
}
